import { ChecklistControl, TagsControl } from '@elfsight/widget-filters';
import type { ActiveFilter, FilterOptions } from '../types';
import { SalaryFilter } from './SalaryFilter';

type FiltersListProps = {
  activeFilters: ActiveFilter[];
  filterOptions: FilterOptions;
};

export function FiltersList({
  activeFilters,
  filterOptions
}: FiltersListProps) {
  return activeFilters.map(({ id, field }) => {
    if (field === 'salary') {
      return (
        <SalaryFilter
          key={id}
          filterName={field}
          options={filterOptions[field]}
        />
      );
    }

    const FilterControl = field === 'skills' ? TagsControl : ChecklistControl;

    return (
      <FilterControl
        key={id}
        filterName={field}
        options={filterOptions[field]}
      />
    );
  });
}
